<template>
  <div class="card-container">
    <div
      class="image-aspect-ratio"
      @click="redirectTo(link)"
    >
      <carousel
        type="image"
        :image-list="imageList"
      />
    </div>

    <div class="content-wrapper">
      <div class="title-group">
        <h2
          class="title"
          @click="redirectTo(link)"
        >
          {{ title }}
        </h2>
        <p class="subtitle">{{ subtitle }}</p>
      </div>

      <p class="description">
        {{ description }}
      </p>

      <div
        class="learn-more"
        @click.prevent="redirectTo(link)"
      >
        <span class="learn-more-text">Learn More</span>
        <span class="arrow">→</span>
      </div>
    </div>
  </div>
</template>

<script>
import Carousel from '@/components/Carousel'

export default {
  name: 'propertyCardComponent',
  components: { Carousel },
  props: {
    title: {
      type: String,
      default: 'Card Title'
    },
    subtitle: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    imageList: {
      type: Array,
      default: () => []
    },
    link: {
      type: String,
      default: '#'
    }
  },
  methods: {
    redirectTo (link) {
      window.open(link, '_blank')
    }
  }
}
</script>

<style scoped>
.card-container {
  position: relative;
  width: 400px;
  height: 620px;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  overflow: hidden;
  box-sizing: border-box;
}

.image-aspect-ratio {
  width: 100%;
  aspect-ratio: 4 / 2.6;
  overflow: hidden;
  cursor: pointer;
  background-color: #b8b8b8;
}

.card-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.card-container:hover .card-image {
  transform: scale(1.05);
}

.content-wrapper {
  padding: 16px;
  display: flex;
  flex-direction: column;
  text-align: left;
}

.title {
  width: fit-content;
  margin: 0;
  font-size: 18px;
  color: #202020;
  font-weight: 500;
  cursor: pointer;
}

.title:hover {
  text-decoration: underline;
}

.subtitle {
  margin: 4px 0 0 0;
  font-size: 14px;
  color: #8c8c8c;
}

.description {
  margin: 20px 0 0 0;
  font-size: 16px;
  line-height: 1.6;
  color: #505050;
  overflow: hidden;
}

.learn-more {
  position: absolute;
  bottom: 20px;
  left: 16px;
  color: #708090;
  font-weight: 500;
  font-size: 16px;
  width: fit-content;
  cursor: pointer;
}

.learn-more-text {
  text-decoration: underline;
  text-underline-offset: 4px;
}

.arrow {
  margin-left: 8px;
}
</style>
